import React, { Component } from "react";
import PropTypes from "prop-types";

import { connect } from "react-redux";
import { openAdvancedSettings } from "../../../../_actions/sidebarSliderActions";
import {
  ADVANCED_ANIMATION_PANEL,
  ADVANCED_EDITOR_EDIT,
  ADVANCED_EDITOR_LAYERS,
} from "../../constants";
import { ReactComponent as IconMotion } from "../../../../assets/icons/motion.svg";
import StudioAnimations from "./StudioAnimations";
import StudioAllLayers from "./StudioAllLayers";
import { FaLayerGroup } from "react-icons/fa";
import {
  Box,
  TabList,
  Tabs,
  Tab,
  HStack,
  Text,
  Flex,
  TabPanels,
  TabPanel,
  Icon,
} from "@chakra-ui/react";

export class StudioAnimationSidebar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: props.rightsidebar.selectedTab,
    };
  }

  onSelectedTabChange = (selectedTabIndex) => {
    if (selectedTabIndex === 0) {
      this.onSelectTab(ADVANCED_EDITOR_EDIT);
    } else if (selectedTabIndex === 1) {
      this.onSelectTab(ADVANCED_EDITOR_LAYERS);
    }
  };

  onSelectTab = (tab) => {
    this.props.openAdvancedSettings(ADVANCED_ANIMATION_PANEL, tab);
  };

  render() {
    const { canvasRef, rightsidebar, editor } = this.props;
    const mime = editor.activeElement.mime;
    const selectedTab = rightsidebar.selectedTab;
    return (
      <>
        <Tabs
          maxH={"100%"}
          defaultIndex={0}
          id="advanced-sidebar-animation-tab"
          onChange={this.onSelectedTabChange}
          isFitted
          isLazy
        >
          <TabList>
            <Tab>
              <HStack>
                <Icon as={IconMotion} fontSize="sm" />
                <Text textTransform={"capitalize"} fontSize={"xs"}>
                  {ADVANCED_EDITOR_EDIT}
                </Text>
              </HStack>
            </Tab>
            {/* Show 'Layers' for 'Artboard' only */}
            <Tab>
              <HStack>
                <Icon as={FaLayerGroup} fontSize="sm" />
                <Text textTransform={"capitalize"} fontSize={"xs"}>
                  {ADVANCED_EDITOR_LAYERS}
                </Text>
              </HStack>
            </Tab>
          </TabList>
          <TabPanels>
            <TabPanel>
              <Flex direction="column" grow="1">
                <StudioAnimations canvasRef={canvasRef}></StudioAnimations>
              </Flex>
            </TabPanel>
            <TabPanel>
              <Box>
                <StudioAllLayers canvasRef={canvasRef}></StudioAllLayers>
              </Box>
            </TabPanel>
          </TabPanels>
        </Tabs>
      </>
    );
  }
}

StudioAnimationSidebar.propTypes = {
  rightsidebar: PropTypes.object.isRequired,
  editor: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  rightsidebar: state.rightsidebar,
  editor: state.editor,
  isMobileView: state.app.isMobileView,
});

const mapDispatchToProps = (dispatch) => ({
  openAdvancedSettings: (panel, selectedTab) =>
    dispatch(openAdvancedSettings(panel, selectedTab)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StudioAnimationSidebar);
